module.exports = "<md-input-container class=space-m-b-n> <label>Sensor name</label> <input type=text ng-blur=$ctrl.save() on-enter=$ctrl.save() ng-model=$ctrl.name /> </md-input-container>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-details/thing-name/thing-name.html
// module id = i3LK
// module chunks = 1